import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/contacts.js';
import q from '../query.js';
export const contactsEntity = 'contacts';
export const contactsKey = 'contacts';
export const useContacts = () => q.query(contactsKey, api.getAll, keys.read.collection(contactsEntity));
//# sourceMappingURL=index.js.map